import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs-compat";
import { FactorModel, InvoiceDetailsModel, InvoiceModel, PrintInvoiceModel } from "src/models/factor.model";
import { LocalStoreManager } from "./local-store-manager.service";
import { ParsianHasPaperModel, ParsianPaymentModel, ParsianPosService, ParsianReceiptBitMapModel, ParsianResponseModel } from "./parsianpos.service";
import { RestApiService } from "./rest-api.service";
import { takeUntil, take } from 'rxjs/operators';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DialogComponent } from "../app/dialog/dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { TableGroupModel } from "../models/tablegroup.model";
import { OrderService } from "./order.service";
import { ShareDataService } from "../providers/sharedata.service";

@Injectable()
export class PosClearingService implements OnDestroy {
  tasvieh: any;
  constructor(public parsianSerice: ParsianPosService,
    private api: RestApiService<any>,
    private storage: LocalStoreManager,
    protected translateText: TranslateService,
    private dialog: MatDialog,
    protected _snackBar: MatSnackBar,
    private order: OrderService,
    private share: ShareDataService) {
  }
  ngUnsubscribe = new Subject<void>();
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  clear(factor?: FactorModel) {
    this.tasvieh = this.storage.getData('Settlement');

    if (!this.tasvieh || this.tasvieh?.Id <= 1 || factor.price === 0) {
      this.clearing(factor);
      return;
    }

    if (this.tasvieh?.Id === 2 || this.tasvieh?.Id === 3 || this.tasvieh?.Id === 4 || this.tasvieh?.Id === 5) {
      this.parsianpayment(factor);
    } else {
      console.warn('نحوه پرداخت پیدا نشد');
    }
  }
  parsianpayment(factor: FactorModel) {
    this.parsianSerice.connect();
    this.parsianSerice.messages.next(new ParsianHasPaperModel);
    this.parsianSerice.messages.subscribe((res: ParsianResponseModel) => {
      if (res?.CP === '-1') {
        const dialogRef = this.dialog.open(DialogComponent);
        dialogRef.componentInstance.title = 'توجه';
        dialogRef.componentInstance.hasCancel = true;
        dialogRef.componentInstance.message = `پرینتر کاغذ ندارد`;
        dialogRef.afterClosed().subscribe(result => {
          return;
        });
      }
      else {
        const payment = new ParsianPaymentModel();
        payment.AM = factor.price.toString();
        this.parsianSerice.messages.next(payment);
        this.parsianSerice.messages.subscribe((res: ParsianResponseModel) => {
          this._snackBar.open('', this.translateText.instant('Message.SaveData'), {
            duration: 10000,
          });
          factor.transactionNo = res?.SN;
          factor.errorMessagePay = res?.ER;
          factor.transactionNo = res?.SN;
          if (res?.RS === '00')
            this.clearing(factor);
        });
      }
    },
      (err: any) => {
        const dialogRef = this.dialog.open(DialogComponent);
        dialogRef.componentInstance.title = 'توجه';
        dialogRef.componentInstance.hasCancel = true;
        dialogRef.componentInstance.message = `خطا در برقراری ارتباط`;
        dialogRef.afterClosed().subscribe(result => {
          return;
        });
      });
  }
  clearing(factor: FactorModel) {
    this.api.postEntity<FactorModel>(factor, 'UpdateFactorState')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: FactorModel) => {
        this._snackBar.open('', this.translateText.instant('Message.SaveData'), {
          duration: 10000,
        });
        this.print(res)

      }
      );
  }
  print(factor: FactorModel) {
    if (this.tasvieh && this.tasvieh?.Id === 2 || this.tasvieh?.Id === 3 || this.tasvieh?.Id === 4 || this.tasvieh?.Id === 5) { //2_saman & 4_irankish also use the same method as parsian
      this.ParsianPrint(factor)
    }
  }
  ParsianPrint(factor: FactorModel) {
    const factorList = [];
    const payment = new ParsianReceiptBitMapModel();
    factorList.push(factor);
    payment.invoice = factorList.maper(new InvoiceModel())[0];
    payment.invoice.invoiceDetail = factorList[0].factorDetail.maper(new InvoiceDetailsModel());
    payment.invoice.restaurantName = this.share.setting.brandName;
    for (const element of payment.invoice.invoiceDetail) {
      if (this.share.setting.currency === 1) element.unitPrice /= 10; //if Toman, convert price to toman
      element.qty = element.qty;
      payment.invoice.sumQty += element.qty;
      payment.invoice.sumPrice += element.qty * element.unitPrice * 10;
      element.sumUnitPrice = element.qty * element.unitPrice * 10;
    }
    if (!payment.invoice.usedCredit)
      payment.invoice.usedCredit = 0;
    payment.invoice.creditPrice = payment.invoice.usedCredit;
    this.parsianSerice.connect();
    this.parsianSerice.messages.next(payment);
    this.parsianSerice.messages.subscribe((res: ParsianResponseModel) => {
      //this.dialogRef.close();
      const print = new PrintInvoiceModel();
      print.branchCode = factor.branchCode;
      print.num = factor.num;
      print.pr = 1;
      this.api.postEntity<FactorModel>(print, 'UpdateInvoicePrintFlag')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: FactorModel) => {
          this.refresh();
        });
    });
  }
  refresh() {
    this.api.getEntity<TableGroupModel[]>('TablesGroup')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: TableGroupModel[]) => {
        if (!res) {
          throw new Error('');
        }
        this.order.tableGroup = res;
        if (!this.share.selectedGroupIndex) {
          this.order.selectedGroup = Object.assign([], this.order.tableGroup[0].tables);
          this.share.selectedGroupIndex = 0;
        }
        else {
          this.order.selectedGroup = Object.assign([], this.order.tableGroup[this.share.selectedGroupIndex].tables);
        }
        this.order.forbidden = false;
        // this.order.startConnection();
        this.order.refreshTableTimeLeft();
        this.order.filter(this.order.selectedFilter);
        //this.tabGroup.selectedIndex = this.share.selectedGroupIndex;
      });
  }
}
